import { defineMessages } from 'react-intl';

export default defineMessages({
  invalidCName: {
    id: 'authenticator.onboarding.form.invalidCName',
    defaultMessage:
      'Use 3 to 40 lowercase letters, digits or dashes, without a dash at the ends',
  },
  cNameAlreadyUsed: {
    id: 'authenticator.onboarding.form.cNameAlreadyUsed',
    defaultMessage: 'This address is already used',
  },
  cNameAvailabilityError: {
    id: 'authenticator.onboarding.form.cNameAvailabilityError',
    defaultMessage:
      'We could not check if this address is available, please try again',
  },
  invalidEmail: {
    id: 'authenticator.onboarding.form.invalidEmail',
    defaultMessage: 'This email is invalid, please use an other one',
  },
  accoundCreationError: {
    id: 'authenticator.onboarding.form.accoundCreationError',
    defaultMessage: 'Account creation failed',
  },
  customerSpaceAddressError: {
    id: 'authenticator.onboarding.form.customerSpaceAddressError',
    defaultMessage:
      'We could not prepare your customer space address, please try again',
  },
});
